"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M7 6.12c-.43-.35-1.06-.3-1.41.13l-4.24 5.11c-.31.37-.31.91 0 1.28l4.24 5.11c.35.43.98.48 1.41.13.43-.35.48-.98.13-1.41L3.42 12l3.71-4.47c.35-.43.3-1.06-.13-1.41zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6-6.88c-.43.35-.48.98-.13 1.41L20.58 12l-3.71 4.47c-.35.43-.29 1.06.13 1.41.43.35 1.06.3 1.41-.13l4.24-5.11c.31-.37.31-.91 0-1.28l-4.24-5.11c-.35-.42-.99-.48-1.41-.13z"
}), 'SettingsEthernetRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/SettingsEthernetRounded.js
// module id = 4801
// module chunks = 0